
import { gql } from '@apollo/client';

export const FLYER_FRAGMENT =  gql`
fragment FlyerDetails on Flyer {
  flyerId
    startDate
    endDate
    submittedAt
    districtId
    isNew
    isUpcoming
    title
    status
    frontImageUrl
    pageCount
    email
    pages {
      imageUrl
      pageNumber
      ocrText
    }
    pdfUrl
    type
    ownerId
    activities
    categories
    schools {
      schoolId
      name
      branding {
        logoAlt
        logoLinkUrl
        logoUrl
      }
    }
    criticalDate
    isFavorite
    isRead
    gradesOrAges
    eventLocation
    mapUrl
    viewsPerDay
    savedAmount
    org {
      orgId
      name
      description
      disclaimer
      schoolApproved
      links {
        call
        website
        email
      }
    }
}`
